<template>
<!--     :disable-button="renewalDays > 360"
 -->
  <div class="padded">

    <el-form label-position="top">

      <el-table
      v-if="tenancy && tenancy.length > 1"
      :data="tenancy"
      border style="width: 100%"
      max-height="250"
      @current-change="checked">

      <el-table-column width="40">
        <template slot-scope="scope">
          <i v-if="renewal.tenancy_id === tenancy[scope.$index].id" class="fa fa-check"></i>
          <i v-else class="fa fa-nothing"></i>
        </template>
      </el-table-column>

      <el-table-column prop="landStatus" label="Land Status" />
      <el-table-column prop="landType" label="Land Type" />
      <el-table-column prop="owner.name" label="Landowner" />

     </el-table>


      <el-row align="middle">
        <el-col :span="24" align="center">
          <h4 v-if="renewal.expiry">Tenancy expires on: <b>{{formatDate(renewal.expiry)}}</b></h4>
          <br />
          <h5><span class="text-black" v-if="owner">{{owner.name}}</span><span class="text-primary">:&nbsp;{{site.siteName}}</span></h5>
          <p v-if="site.handover"><center>Handover: {{formatDate(site.handover)}}<span v-if="tenancy.deposit"> | Deposit: {{formatMoney(tenancy.deposit)}}</span><span v-if="tenancy.depositMonths">&nbsp;for {{plural('month', tenancy.depositMonths, true)}}</span></center></p>
          <hr />
        </el-col>
      </el-row>

      <small v-if="prevStarted && prevExpiry"><center>Previous Renewal from <b>{{formatDate(prevStarted)}}</b> to <b>{{formatDate(prevExpiry)}}</b>.</center></small>

      <!-- Date Stuff -->
      <el-row :gutter="8">

        <el-col :span="8">
          <date-input label="Started" v-model="renewal.started" @change="onChange" />
        </el-col>

        <el-col :span="8">
          <el-form-item label="Tenor (months)">
             <el-col :span="18">
                <el-slider v-model="renewal.months" :min="6" :max="1188" :step="6" show-input @change="onChange"  />
            </el-col>

            <el-col :span="6">
              <b>{{Number(renewal.months / 12)}}</b> {{plural('year', renewal.months / 12)}}
            </el-col>
          </el-form-item>
        </el-col>

        <el-col :span="6" align="center">
          <el-form-item label="Expiry">
            <b>{{formatDate(renewal.expiry)}}</b>
          </el-form-item>
        </el-col>
      </el-row>


      <!-- Financial Stuff -->
      <el-row :gutter="8">

        <el-col :md="24" :lg="14">

            <el-col :span="8">
              <currency-input v-model="renewal.amount" @change="onChange" />
            </el-col>
            <el-col :span="6">
               <check-box  label="Taxable" v-model="renewal.taxable" @change="onChange" />
            </el-col>

            <el-col :span="10">
            <el-form-item label="Increment %">
              <el-slider v-model="renewal.increment" :min="0" :max="1000"  show-input @change="onChange" />
            </el-form-item>
          </el-col>

        </el-col>

        <el-col :xs="8" :sm="8" :md="8" :lg="4" align="center">
          <el-form-item label="Amount">
           <b>{{formatMoney(renewal.amount)}}</b>
         </el-form-item>
        </el-col>

        <el-col v-if="renewal.taxable" :xs="8" :sm="8" :md="8" :lg="2" align="center">
          <el-form-item label="Tax">
          <b>{{formatMoney(renewal.tax)}}</b>
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="8" :md="8" :lg="4" align="center">
          <el-form-item label="Total">
          <b>{{formatMoney(renewal.total)}}</b>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form>

  </div>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import TenancyMixins from '@/mixins/TenancyMixins'

export default {
  mixins: [TenancyMixins],

  props: {

    tenancyData: {
      type: Object,
      required: true
    },

    siteData: {
      type: Object,
      default: null
    },

    renewalIndex: {
      type: Number,
      default: 0
    }

  },

  methods: {

    init () {

      if (this.renewal) {

        if (!this.renewal.tenancy_id) {
          this.renewal.tenancy_id = this.tenancy.id
        }

        this.onChange()

        if (!this.renewal.months) {
          this.renewal.months = 12
        }

        this.renewal.increment = Number(this.renewal.increment)
      }

    },


    checked (val) {
      if (val) {
        this.renewal.tenancy_id = val.id
        this.owner = val.owner
      }
    },



    onChange () {

      this.renewal = this.renewalCalc(this.renewal, this.renewal.amount, this.renewal.increment, this.renewal.taxable)
      this.$emit('change', this.renewal, this.renewalIndex)
    }


  },


  watch: {

    tenancyData: function (tenancy) {
      this.tenancy = tenancy
      this.owner = this.tenancy && this.tenancy.owner ? this.tenancy.owner : null
      this.renewal = this.tenancy && this.tenancy.renewal ? this.clone(this.tenancy.renewal) : this.getTableStruct('tenancy_renewals')

      this.currentAmount = Number(this.renewal.amount)

      this.prevStarted = this.renewal && this.renewal.started
          ? this.renewal.started
          : new Date()

      this.prevExpiry = this.renewal && this.tenancyData.renewal.expiry
          ? this.renewal.expiry
          : this.contractExpiryDate(new Date(), this.tenancyData.months, 'months')

      this.init()
    },

    renewal: function (newValue) {
      this.onChange()
    }

  },



  data () {

    return {

      site: this.siteData ? this.siteData : this.tenancyData.site,

      tenancy: this.tenancyData,
      owner: this.tenancyData && this.tenancyData.owner ? this.tenancyData.owner : null,

      prevStarted: this.tenancyData &&
        this.tenancyData.renewal &&
        this.tenancyData.renewal.started
          ? this.tenancyData.renewal.started
          : (this.tenancyData.started
            ? this.tenancyData.started
            : null),

      prevExpiry: this.tenancyData && this.tenancyData.renewal &&
        this.tenancyData.renewal &&
        this.tenancyData.renewal.expiry
          ? this.tenancyData.renewal.expiry
          : (this.tenancyData.renewal && this.tenancyData.renewal.expiry
            ? this.tenancyData.renewal.expiry
            : null),

      currentAmount: this.tenancyData && this.tenancyData.renewal && this.tenancyData.renewal.amount ? Number(this.tenancyData.renewal.amount).toFixed(2) : 0,

      renewal: this.tenancyData && this.tenancyData.renewal ? this.clone(this.tenancyData.renewal) : this.getTableStruct('tenancy_renewals'),

      allowEdit: false
    }

  },



  created () {

    if (this.renewal) {

      if (this.renewal.id) {
        delete this.renewal.id
      }

      this.renewal.term++
      this.renewal.started = this.addDate(this.renewal.expiry, 1, 'days')
      this.renewal.expiry = this.contractExpiryDate(this.renewal.started, this.renewal.months, 'months')

    } else {

      this.renewal = this.getTableStruct('tenancy_renewals')

    }

    this.allowEdit = (this.currentAmount === 0 || !this.currentAmount)

    this.init()
  },

  beforeDestroy () {
    this.onChange()
  }

}

</script>



// WEBPACK FOOTER //
// Renewal.vue?1bacb510